<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<div style="color:#409eff;cursor: pointer;margin-bottom:40px;width: 100%;line-height: 40px;margin-bottom: 40px;">
				<span style="color:#409eff;cursor: pointer;" @click="dycourseFlag =true">如何发抖音？</span>
				<el-button type="primary" style="float: right" @click="toSendDouyin">发抖音</el-button>
			</div>
		</div>
		<div :class="classNames+'_con'" v-if="videolist.list">
			<div style="width: 100%">
				<el-table
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}"
			      	:data="videolist.list"
			      >
				  <div slot="empty">
						<img src="@/assets/image/empty.png" style="width: 100%;padding: 115px 0;"/>
					</div>
			      <el-table-column
			        prop="title"
			        width="490">
			        <template slot="header" slot-scope="scope">
				        <span style="font-size: 14px;font-weight: 600;color: black">作品</span>
				    </template>
				    <template slot-scope="scope">
				        <div class="line1">
				        	<div style="" class="text-line">
				        		<span>{{scope.row.duration}}</span>
				        	</div>
				        	<img class="avder" :src="scope.row.img" />
				        	<div class="right-main" >
				        		<p style="font-weight: 600;color: #37383c">{{scope.row.title}}</p>
				        		<span style="margin-right:30px"><i class="el-icon-view" style="margin-right: 5px"></i>{{scope.row.view_count}} </span>
				        		<span style="margin-right:30px"><i class="el-icon-chat-line-square" style="margin-right: 5px"></i>{{scope.row.comm_count}}</span>
				        		<span style="margin-right:30px"><i class="el-icon-star-off" style="margin-right: 5px"></i>{{scope.row.like_count}}</span>
				        		<p style="position: absolute;top: 130px">
				        			<!-- <span style="" class="shenhezhong" v-statusColor="{status:scope.row.status, list: statusList }"></span> -->
				        			<span style="margin: 5px">{{scope.row.created_time}}</span>
				        		</p>
				       		</div>
				       </div>
				      </template>
			      </el-table-column>
			      <el-table-column
			        prop="product_title"
			        label="挂载的课程"
			        width="392">
			         <template slot="header" slot-scope="scope">
				        <span style="font-size: 14px;font-weight: 600;color: black">挂载的课程</span>
				    </template>
				     <template slot-scope="scope">
				        <p style="color: #37383c;margin: 20px 0">{{scope.row.product_title}}</p>
				        <p>{{scope.row.price}}</p>
				      </template>
			      </el-table-column>
			      <el-table-column
			        prop="address"
			        label="操作">
			         <template slot="header" slot-scope="scope">
				        <span style="font-size: 14px;font-weight: 600;color: black;float: right;">操作</span>
				    </template>
				    <template slot-scope="scope">
				        <el-button
				          size="mini"
				          @click="handleEdit(scope.row)" style="float:right">删除视频</el-button>
				       
				      </template>
			      </el-table-column>
			    </el-table>
			</div>
			<div style="display: flex;align-items: center;justify-content: center;cursor: pointer;" v-if="videolist.page_info &&Math.ceil(videolist.page_info.total_count/searchObj.page_size) > 1">
				<span class="first_page page_title" @click="firstPage">首页</span>
						<el-pagination
						 style="text-align: center;margin: 30px"
					  background
					  layout="prev, pager, next"
					  :current-page.sync="page"
					   @current-change="handleCurrentChange"
					  :total="videolist.page_info.total_count">
					</el-pagination>
				<span class="end_page page_title" @click="endPage">尾页</span>
			</div>
			
			<!-- <Pagination v-if="videolist" @change="changeSize" :total="videolist.page_info.total_count" ref="pagination" v-model="searchObj.page"></Pagination> -->
			
		</div>
		<tiktok-dialog v-model="dycourseFlag"></tiktok-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import { common } from '../mixin/common.js'
	import { uploadCopyRight } from '../mixin/uploadCopyRight.js'
	import multipleUploadImg from '@/components/upload/multiple_upload_img.vue'
	// import html2canvas from 'html2canvas';
	import TiktokDialog from '@/components/tiktok/tiktok.vue'
	export default {
		name: 'singleClass',
		mixins: [common, uploadCopyRight],
		data() {
			return {
				classNames: 'sendClass',
				value: '',
				input3: '',
				page:1,
				searchObj: {
					page: 1,
					page_size: 10
				},
				changeSize:10,
				headerList: [
				{
					prop: 'id',
					label: '作品',
					width: 400
				},
				// {
				// 	prop: 'sort',
				// 	label: '排序'
				// },
				{
					prop: 'singleClassobj',
					label: '挂载的课程',
					width: 400
				},
				// {
				// 	prop: 'price',
				// 	label: '价格'
				// },
				// {
				// 	prop: 'duration',
				// 	label: '时长'
				// },
				// {
				// 	prop: '',
				// 	label: '浏览/购买/评价',
				// 	width: 300
				// },
				// {
				// 	prop: 'status',
				// 	label: '状态'
				// },
				// {
				// 	prop: 'reason',
				// 	label: '驳回原因/下架原因'
				// },
				// {
				// 	prop: 'created_time',
				// 	label: '创建时间'
				// }
			],
			statusList: [
				{
					label: '审核中',
					value: 1,
					color: '#FFA555'
				},
				{
					label: '审核失败',
					value: 2,
					color: '#EC4561'
				},
				{
					label: '审核成功',
					value: 3,
					color: '#5ADDB3'
				},
				{
					label: '不适合公开',
					value: 5,
					color: '#EC4561'
				},
			],
			dycourseFlag: false
			}
		},
		created() {
			this.getData()
		},
		components: {
			Pagination,
			multipleUploadImg,
			'tiktok-dialog': TiktokDialog
		},
		computed: {
			...mapState('createDynamic',['videolist'])
		},
		// filters: {
		// 	handleStatus(value) {
		// 		switch(value) { 
		// 			case -2:
		// 				return '下架'
		// 			case -1:
		// 				return ''
		// 			case 1:
		// 				return '上架'
		// 			case 2:
		// 				return '驳回'
		// 			case 3:
		// 				return '待审核'
		// 			case 4:
		// 				return '草稿'
		// 			default:
		// 				return ''
		// 		}
		// 	}
		// },
		methods: {
			...mapActions('createDynamic', ['acvideolist','deletevideo']),
			handleCurrentChange(e){
				this.searchObj.page = e
				this.getData()
			},
			handleEdit(row){
				console.log(row)
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	this.deleteEvent(row)
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消删除'
		          });          
		        });
			},
			async deleteEvent(row){
				let res = await this.deletevideo({video_id:row.id})
			          this.$message({
			            type: 'success',
			            message: '删除成功!'
			          });
			        this.getData()
			},
			toSendDouyin(){
				this.$router.push({
						path:'/createDynamic'
					})	
			},
			getData(){
				this.acvideolist(this.searchObj)
			},
			firstPage() {
				this.page =1
				this.searchObj.page = 1
				this.getData()
			},
			endPage() {
				 console.log(this.videolist)
				this.page = this.videolist.page_info.total_page
				this.searchObj.page = this.page
				this.getData()
			},
		},
		directives: {
			statusColor: {
				bind(el, binding) {
					let {status, list} = binding.value
					let obj = list.find(item => item.value == status)
					el.style.border=`1px solid ${obj.color}`
					el.style.color=obj.color
					el.innerHTML = obj ? obj.label: ''
				},
				update(el,binding) {
					let {status, list} = binding.value
					let obj = list.find(item => item.value == status)
					el.style.border=`1px solid ${obj.color}`
					el.style.color=obj.color
					el.innerHTML = obj ? obj.label: ''
				}
			}
		},
		watch: {
			searchObj: {
				deep: true,
				handler(news) {
					// this.getClassLists(news)
				}
			}
		}
	}
</script>
<style lang="less">
	@classNames: sendClass;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search_btn {
			width: 70px;
			height: 40px;
			background: #1989FA;
			border-radius: 0px 2px 2px 0px;
			color: #FFFFFF;
			font-size: 14px;
		}
		.@{classNames}_operation_title {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			// &:not(:last-child) {
			// 	margin-right: 12px;
			// }

		}
		.@{classNames}_table_imgtitle {
			display: flex;
			height: 123px;
			.@{classNames}_table_imgtitle_left {
				position: relative;
				margin-right: 10px;
				width: 163px;
				height: 123px;
				flex-shrink: 0;
				img {
					width: 100%;
					height: 100%;
				}
				span {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 26px;
					background: #000000;
					opacity: 0.5;
					text-align: center;
					line-height:26px;
					font-size: 14px;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
			.@{classNames}_table_imgtitle_right {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.@{classNames}_table_right_top {
					.@{classNames}_table_right_title {
						width: 155px;
						font-size: 14px;
						color: #606266;
						line-height: 20px;
						overflow: hidden;
						display: -webkit-box;
						white-space: pre-wrap;
						word-wrap: break-word;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
					.@{classNames}_table_right_price {
						margin-top: 14px;
						font-size: 16px;
						font-weight: 500;
						color: #EC4561;
						line-height: 20px;
					}
				}
				.@{classNames}_table_right_bot {
					.@{classNames}_table_bot_status {
						display: flex;
						align-items: center;
						.@{classNames}_table_bot_status_tit {
							width: 66px;
							height: 24px;
							border-radius: 12px;
							margin-right: 10px;
							text-align: center;
							line-height: 24px;
						}
						.@{classNames}_table_bot_reason {
							font-size: 14px;
							color: #65B2FF;
							line-height: 20px;
						}
					}
					.@{classNames}_table_bot_time {
						font-size: 14px;
						color: #606266;
						line-height: 14px;
						margin-top: 8px;
					}
				}
			}
		}
		.@{classNames}_search_con_item {
			.el-input-group__append {
				background: #1989FA;
				color: #fff;
			}
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				width: 77px;
				height: 28px;
				padding: 0;
				text-align: center;
				line-height: 28px;
			}
		}
	}
	.uploadCopyright {
		margin-top: 24px;
		min-height: 40%;
		width: 400px!important;
		display: flex;
		flex-direction: column;
		.el-dialog__body {
			flex: 1;
			.uploadCopyright_con {
				display: flex;
				flex-direction: column;
				align-items: center;
				>p {
					color: red;
				}
			}
		}
	}
	.view_buy_comm {
		span {
			&:not(:first-child) {
				margin-left: 24px;
			}
			.iconfont {
				margin-right: 4px;
			}
		}
	}
	.page_title {
			color: #606266;
			font-size: 14px;
			cursor: pointer;
		}
</style>
<style lang='less' scoped>
	@classNames: sendClass;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		/* overflow: hidden; */

		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			// margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
	.line1{
		position: relative;
		display: flex;
		.avder{
			width: 120px;
			height: 160px;
			border-radius:5px;
		}
		.text-line{
			position: absolute;
			bottom: 0px;
			text-align: right;
			width: 120px;
			font-size: 12px;
			padding-right: 10px;
			color: #ffffff;
		}
		.right-main{
			width: calc(100% - 130px);
			position: relative;
			padding:5px 20px;
			.shenhezhong{
				padding: 1px 5px;border-radius: 10px;font-size: 12px
			}
		}
	}
</style>
